import { ValidatorConstraint, ValidatorConstraintInterface, ValidationArguments } from 'class-validator';
import { validateSync } from 'class-validator';
import { GoldenRecordSubTypePatternDto } from '../model/dto/GoldenRecordSubTypePatternDto';

@ValidatorConstraint({ name: 'GoldenRecordExchangePatternValidator', async: false })
export class GoldenRecordExchangePatternValidator implements ValidatorConstraintInterface {
  validate(value: any, args: ValidationArguments) {
    if (Array.isArray(value) && value.every(item => typeof item === 'string')) {
      return true;
    }

    if (value !== null && typeof value === 'object') {
      for (const key in value) {
        if (Array.isArray(value[key])) {
          const errors = validateSync(new GoldenRecordSubTypePatternDto(), value[key]);
          if (errors.length > 0) {
            return false;
          }
        } else {
          return false;
        }
      }
      return true;
    }

    return false;
  }

  defaultMessage(args: ValidationArguments) {
    return 'Pattern must be either an array of strings or a record with arrays of GoldenRecordSubTypePatternDto';
  }
}
